import { render, staticRenderFns } from "./EditarModulo.vue?vue&type=template&id=6165883e"
import script from "./EditarModulo.vue?vue&type=script&lang=js"
export * from "./EditarModulo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports